import React from "react";
import numeral from "numeral";
import styled from "styled-components";
import { LabelDecimal, LabelDollarFormatted, LabelString, LabelPercentFormatted, MaterialIcon } from "@loanbossinc/component-library";

const StyledLenderCell = styled.div`
&& {
  display: flex;
  flex-direction: column;
  border: none;

  span {
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
  }

  .loan-type {
    font-family: Work Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    color: ${(props) => props.isSelected ? "#FFFFFF" : "#5F6368"};
  }
}`;

const StyledLabelString = styled(LabelString)`
&& {
  font-family: Work Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
    color: ${(props) => props.isSelected ? "#FFFFFF" : "#5F6368"};
}
`;

export const lenderPassedColumns = [
  {
    id: "lender",
    label: "LENDER",
    path: "lender",
    alignHeader: "left",
    Cell: (value, isSelected) => (
      <StyledLenderCell isSelected={isSelected}>
        <StyledLabelString value={value.name ? value.name.trim() : "--"} isSelected={isSelected} />
        {value.loanType && <LabelString className="loan-type" isSelected={isSelected} value={value.loanType ? value.loanType.trim() : "--"} />}
      </StyledLenderCell>
    )
  },
  {
    id: "reasonforPassing",
    label: "Reason for Passing",
    path: "passReason.name",
    alignHeader: "left",
    Cell: (value, isSelected) => (
      <StyledLenderCell isSelected={isSelected}>
        <StyledLabelString value={value ? value.trim() : "--"} isSelected={isSelected} />
      </StyledLenderCell>
    )
  },
  {
    id: "passComment",
    label: "Comment",
    path: "passComment",
    alignHeader: "left",
    Cell: (value, isSelected) => (
      <StyledLenderCell isSelected={isSelected}>
        <StyledLabelString value={value ? value.trim() : "--"} isSelected={isSelected} />
      </StyledLenderCell>
    )
  }
];

export const defaultColumns = [
  {
    id: "lender",
    label: "LENDER",
    path: "lender",
    alignHeader: "left",
    Cell: (value, isSelected) => (
      <StyledLenderCell isSelected={isSelected}>
        <StyledLabelString value={value.name ? value.name.trim() : "--"} isSelected={isSelected} />
        {value.loanType && <LabelString className="loan-type" isSelected={isSelected} value={value.loanType ? value.loanType.trim() : ""} />}
      </StyledLenderCell>
    )
  },
  {
    id: "ltvStabilized",
    label: "LTV/AMOUNT",
    path: "ltvAndAmount",
    alignHeader: "left",
    Cell: (value, isSelected) => {
      const hasltv = value.ltv !== null;
      const hasamount = value.amount !== null;
      if (hasltv && hasamount) {
        return (
          <div>
            <LabelPercentFormatted value={value.ltv} decimals={0} isSelected={isSelected} />
            <LabelDollarFormatted value={numeral(value.amount).format("($0,0.00a)")} decimals={0} isSelected={isSelected} />
          </div>
        );
      }

      return (
        <div>
          {value.ltv && <LabelPercentFormatted value={value.ltv} decimals={0} isSelected={isSelected} />}
          {value.amount && <LabelDollarFormatted value={value.amount} decimals={0} isSelected={isSelected} />}
        </div>
      );
    }
  },
  {
    id: "loanTermMonths",
    label: "TERM",
    path: "loanTermMonths",
    alignHeader: "left",
    Cell: (value, isSelected) => <LabelDecimal value={value} decimals={0} isSelected={isSelected} />
  },
  {
    id: "loanPricing",
    label: "PRICING",
    path: "loanPricing",
    alignHeader: "left",
    Cell: (value, isSelected) => <LabelString style={{ fontFamily: "Space Mono" }} value={value} isSelected={isSelected} />
  },
  {
    id: "hasTermSheet",
    label: "",
    path: "hasTermSheet",
    align: "right",
    alignHeader: "left",
    Cell: (value, isSelected) => {
      if (!value) {
        return null;
      }

      const iconColor = isSelected ? "#FFFFFF" : "#005AA9";
      return (<MaterialIcon iconName={"assignment"} style={{ "color": iconColor }} />);
    }
  }
];

export const slColumns = [
  {
    id: "grip",
    label: "",
    path: "",
    align: "left",
    alignHeader: "left",
    Cell: (value, isSelected) => <MaterialIcon iconName={"drag_indicator"} style={{ "width": "0px" }} />
  },
  {
    id: "lender",
    label: "LENDER",
    path: "lender",
    alignHeader: "left",
    Cell: (value, isSelected) => (
      <StyledLenderCell isSelected={isSelected}>
        <StyledLabelString value={value.name ? value.name.trim() : "--"} isSelected={isSelected} />
        {value.loanType && <LabelString className="loan-type" isSelected={isSelected} value={value.loanType ? value.loanType.trim() : ""} />}
      </StyledLenderCell>
    )
  },
  {
    id: "ltvStabilized",
    label: "LTV/AMOUNT",
    path: "ltvAndAmount",
    alignHeader: "left",
    Cell: (value, isSelected) => {
      const hasltv = value.ltv !== null;
      const hasamount = value.amount !== null;
      if (hasltv && hasamount) {
        return (
          <div>
            <LabelPercentFormatted value={value.ltv} decimals={0} isSelected={isSelected} />
            <LabelDollarFormatted value={numeral(value.amount).format("($0,0.00a)")} decimals={0} isSelected={isSelected} />
          </div>
        );
      }

      return (
        <div>
          {value.ltv && <LabelPercentFormatted value={value.ltv} decimals={0} isSelected={isSelected} />}
          {value.amount && <LabelDollarFormatted value={value.amount} decimals={0} isSelected={isSelected} />}
        </div>
      );
    }
  },
  {
    id: "loanTermMonths",
    label: "TERM",
    path: "loanTermMonths",
    alignHeader: "left",
    Cell: (value, isSelected) => <LabelDecimal value={value} decimals={0} isSelected={isSelected} />
  },
  {
    id: "loanPricing",
    label: "PRICING",
    path: "loanPricing",
    alignHeader: "left",
    Cell: (value, isSelected) => (<LabelString style={{ fontFamily: "Space Mono" }} value={value} isSelected={isSelected} />)
  },
  {
    id: "hasTermSheet",
    label: "",
    path: "hasTermSheet",
    align: "right",
    alignHeader: "left",
    Cell: (value, isSelected) => {
      if (!value) {
        return null;
      }
      const iconColor = isSelected ? "#FFFFFF" : "#005AA9";
      return (<MaterialIcon iconName={"assignment"} style={{ "color": iconColor }} />);
    }
  }
];
